/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import Text from '../../Text';
import CustomInput from '../../CustomInput';
import CTA from '../../CTA';
import routes from '../../../../routes';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { CourseCardCta, CoursesWrapper } from './style';
import CustomToggle from '../../CustomToggle';
import {
  COURSE_CREATED_LIST_GET,
  COURSE_CREATED_LIST_RESET,
  SAVE_PRINT_SETTINGS,
} from '../../../../app/redux/actions/statistics';
import NoResult from '../../NoResult';
import { EXPORT_TABS } from '.';

const CoursesTab = ({
  list,
  printSettings,
  getCourseCreatedList,
  savePrintSettings,
  resetCourseCreated,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const onClickCourse = (item) => {
    const { id } = item;
    const newCourses = [...printSettings.selectedCourses];
    const idx = printSettings.selectedCourses?.findIndex((c) => c?.id === id);
    if (idx < 0) newCourses.push(item);
    else newCourses.splice(idx, 1);
    savePrintSettings({
      key: 'selectedCourses',
      value: newCourses,
    });
    setSearchValue('');
    resetCourseCreated();
  };

  const debounceSearch = debounce((v) => {
    setSearchValue(v);
    getCourseCreatedList({
      search_text: v,
      items_per_page: 20,
    });
  }, 300);

  return (
    <div className="pr-3">
      <Text type="h2" mb={8}>
        Percorsi formativi
      </Text>
      <Text type="b3" mb={24}>
        Da questa sezione puoi aggiungere i percorsi formativi che hai creato
        cercando per titolo o codice per poi selezionare le relative
        impostazioni.
      </Text>
      <div className="d-flex sb mb-3">
        <CustomInput
          size="l"
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value={searchValue}
          icon="search-sm"
          isClearable
          onChange={(v) => {
            if (v?.length > 2) {
              debounceSearch(v);
            } else setSearchValue();
          }}
        />
        <CTA
          type="tertiary"
          btnText="Catalogo percorsi formativi"
          icon="link-external-02"
          onClick={() => window.open(`${routes.tutorCourseList.path}`)}
        />
      </div>
      <CoursesWrapper>
        {/* Course results */}
        {searchValue && (
          <div className="courses-container has-scrollbar">
            {list?.length > 0 ? (
              <>
                {list
                  .filter(
                    (course) =>
                      printSettings?.selectedCourses?.findIndex(
                        (selectedCourse) => selectedCourse?.id === course?.id
                      ) < 0
                  )
                  .map((item, i) => (
                    <div className="course-card" key={`card-${i}`}>
                      <Text type="b4" className="info">
                        {item?.code}
                        {item?.typology && <span> | {item?.typology}</span>}
                        {item?.category && <span> | {item?.category}</span>}
                      </Text>
                      <Text
                        type="h3"
                        className="ellipsis"
                        onClick={() => onClickCourse(item)}
                      >
                        {item?.title}
                      </Text>
                    </div>
                  ))}
              </>
            ) : (
              <div style={{ marginTop: '30px' }}>
                <NoResult />
              </div>
            )}
          </div>
        )}
        {/* Added courses */}
        <>
          {printSettings?.selectedCourses?.length > 0 ? (
            <div>
              <Text type="b3" mb={16}>
                {printSettings?.selectedCourses?.length} corsi aggiunti
              </Text>
              {printSettings?.selectedCourses?.map((item, i) => (
                <CourseCardCta key={`card-${i}`}>
                  <Text type="b3" className="code">
                    {item?.code}
                  </Text>
                  <div className="ellipsis">
                    {item?.typology && (
                      <Text type="b4" className="typology">
                        {item?.typology === 'event' ? 'Evento' : 'Corso'}
                      </Text>
                    )}
                    <Text type="h3" className="ellipsis">
                      {item?.title}
                    </Text>
                  </div>
                  <CTA
                    type="tertiary"
                    bottomRight
                    btnText="Rimuovi"
                    icon="x"
                    onClick={() => onClickCourse(item)}
                  />
                </CourseCardCta>
              ))}
            </div>
          ) : (
            <Text type="b3" mt={24} className="no-course-msg">
              Nessun percorso formativo aggiunto, selezionane almeno uno per
              abilitare l’export.
            </Text>
          )}
        </>
        {/* Settings */}
        {printSettings?.selectedCourses?.length > 0 && (
          <div className="courses-settings">
            <Text type="h3" mb={8}>
              Impostazioni
            </Text>
            <Text type="b4" mb={40}>
              Seleziona quale contenuto vuoi includere nel file di export
            </Text>
            <div className="d-flex sb setting">
              <Text type="h3">Attività/Sessioni</Text>
              <CustomToggle
                checked={printSettings?.activities || false}
                onClick={() =>
                  savePrintSettings({
                    key: 'activities',
                    value: !printSettings?.activities,
                  })
                }
              />
            </div>
            <div className="d-flex sb setting">
              <Text type="h3">Utenti</Text>
              <CustomToggle
                checked={printSettings?.users || false}
                onClick={() =>
                  savePrintSettings({
                    key: 'users',
                    value: !printSettings?.users,
                  })
                }
              />
            </div>
            <div className="d-flex sb setting">
              <Text type="h3">Survey</Text>
              <CustomToggle
                checked={printSettings?.survey || false}
                onClick={() =>
                  savePrintSettings({
                    key: 'survey',
                    value: !printSettings?.survey,
                  })
                }
              />
            </div>
          </div>
        )}
      </CoursesWrapper>
    </div>
  );
};

CoursesTab.propTypes = {
  list: PropTypes.array,
  printSettings: PropTypes.object,
  getCourseCreatedList: PropTypes.func,
  savePrintSettings: PropTypes.func,
  resetCourseCreated: PropTypes.func,
};

export default connect(
  (state) => {
    const { list } = state.statistics.course.createdCourses;
    const { courses: printSettings } = state.statistics.printSettings;
    return { list, printSettings };
  },
  (dispatch) => ({
    getCourseCreatedList: (filters) =>
      dispatch({ type: COURSE_CREATED_LIST_GET._REQUEST, filters }),
    savePrintSettings: ({ key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        key,
        value,
        tab: EXPORT_TABS.COURSES,
      }),
    resetCourseCreated: () => dispatch({ type: COURSE_CREATED_LIST_RESET }),
  })
)(withMediaQueries(CoursesTab));
